import { Component, inject } from '@angular/core';
import { GeneralInfoComponent } from "../article-artistic-cards/general-info/general-info.component";
import { ObjectComponent } from "../article-artistic-cards/object/object.component";
import { LocationDataComponent } from "../article-artistic-cards/location-data/location-data.component";
import { ChronologyComponent } from "../article-artistic-cards/chronology/chronology.component";
import { CulturalDefinitionComponent } from "../article-artistic-cards/cultural-definition/cultural-definition.component";
import { TechnicalDataComponent } from "../article-artistic-cards/technical-data/technical-data.component";
import { ConservationComponent } from "../article-artistic-cards/conservation/conservation.component";
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ConnectServerService } from '../../../services/connect-server.service';
import { ApiResponse } from '../../../interfaces/api-response';
import { SelectOptions } from '../interfaces/select-options';
import { SelectComplete } from '../interfaces/select-complete';
import { AnalyticalDataComponent } from "../article-artistic-cards/analytical-data/analytical-data.component";
import { SelectChronology } from '../interfaces/select-chronology';
import { LegalConditionComponent } from "../article-artistic-cards/legal-condition/legal-condition.component";
import { SelectCulturalDefinition } from '../interfaces/select-cultural-definition';
import { SelectTechnicalData } from '../interfaces/select-technical-data';
import { SourcesComponent } from "../article-artistic-cards/sources/sources.component";
import { SelectDataAnalyticalData } from '../interfaces/select-data-analytical-data';
import { SelectSourcesDefinition } from '../interfaces/select-sources-definition';
import { SelectLegalConditions } from '../interfaces/select-legal-conditions';
import { GeographicLocationComponent } from '../article-artistic-cards/geographic-location/geographic-location.component';
import { RelationsComponent } from "../article-artistic-cards/relations/relations.component";

@Component({
    selector: 'app-article-artistic-update',
    imports: [
        GeneralInfoComponent,
        ObjectComponent,
        LocationDataComponent,
        ChronologyComponent,
        CulturalDefinitionComponent,
        TechnicalDataComponent,
        ConservationComponent,
        AnalyticalDataComponent,
        LegalConditionComponent,
        SourcesComponent,
        GeographicLocationComponent,
        RelationsComponent,
        RouterLink,
    ],
    templateUrl: './article-artistic-update.component.html',
    styleUrl: './article-artistic-update.component.scss'
})
export class ArticleArtisticUpdateComponent {

  idarticle = 0;
  readonly route = inject(ActivatedRoute);

  listComplete: SelectComplete | null = null;
  listChronology: SelectChronology | null = null;
  listCulturalDefinition: SelectCulturalDefinition | null = null;
  listTechnicalData: SelectTechnicalData | null = null;
  statusOptions: SelectOptions[] | null = null;
  listAnalyicalData: SelectDataAnalyticalData | null = null;
  listLegal: SelectLegalConditions | null = null;
  listSourcesData: SelectSourcesDefinition | null = null;

  constructor(private connectServerService: ConnectServerService) {}

  goBack(): void {
    window.history.back();
  }

  ngOnInit(): void {
    const parameters = this.route.snapshot.paramMap.get('id');
    if (parameters) {
      this.route.params.subscribe(
        (params) => {
          //console.error('params: ', params['name'])
          this.idarticle = params['id'];
          this.getSelectOptions();
        }
      );
    }
  }

  getSelectOptions() {
    this.connectServerService.getRequest('listAADefinition', {})
      .subscribe(
        (val: ApiResponse<{ listComplete: SelectComplete }>) => {
          this.listComplete = val.data.listComplete;
          this.listChronology = {
            listChronCentury: this.listComplete.listChronCentury,
            listChronValV: this.listComplete.listChronValV,
            listChronValF: this.listComplete.listChronValL,
            listChronReason: this.listComplete.listChronReason
          }

          this.listCulturalDefinition = {
            listAuthorAuth: this.listComplete.listAuthorAuth,
            listAuthorInt: this.listComplete.listAuthorInt,
            listAuthorReason: this.listComplete.listAuthorReason,
            listScopeDen: this.listComplete.listScopeDen,
            listScopeRef: this.listComplete.listScopeRef,
            listScopeReason: this.listComplete.listScopeReason,
          };
          this.listTechnicalData = {
            materialOptions: this.listComplete.materialOptions,
            unitOptions: this.listComplete.unitOptions,
            missingOptions: this.listComplete.missingOptions,
            validityOptions: this.listComplete.validityOptions
          }
          this.statusOptions = this.listComplete.statusOptions;
          this.listAnalyicalData = {
            membershipClassSub: this.listComplete.membershipClassSub,
            language: this.listComplete.language,
            technique: this.listComplete.technique,
            charactersType: this.listComplete.charactersType,
            qualification: this.listComplete.qualification,
            membershipClassArm: this.listComplete.membershipClassArm,
          }
          this.listLegal = {
            acquisitionType: this.listComplete.acquisitionType,
            listGenericIndication: this.listComplete.listGenericIndication
          };
          this.listSourcesData = {
            listTypeSource: this.listComplete.listTypeSource,
            listGenreSource: this.listComplete.listGenreSource
          }
        }
      )
  }

  onButtonClicked() {
    // console.log('Il bottone nel componente figlio è stato cliccato!');
  }

}
